import { RecordUnknown } from '../types/utils';

import { ValidationSchema } from './types';

export function validate<T extends RecordUnknown>(data: T, schema: ValidationSchema<T>): boolean {
    return schema.isValidSync(data);
}
